import Head from 'next/head';
import Loyalty from '../../../components/loyalty';
import logo from '../../../public/images/kellileigh.png';
import image from '../../../public/images/unconditional.jpg';
import Image from "next/legacy/image";
import ImageStack from '../../../components/ImageStack';
import useCountdown from '../../../hooks/useCountdown';

const Kelli = () => {
    const countdown = useCountdown('2024-03-08T00:00:00Z');

    return <>
        <style jsx global>{`
  body {
    background: white;
  }
`}</style>
        <Head>
            <title>Salsa: Musician Loyalty</title>
            <meta name="og:title" content="Salsa: Musician Loyalty" />
        </Head>
        <div style={{
            background: "#fd652e",
            marginBottom: -20,
            padding: 6,
            textAlign: "center",
            fontWeight: 500
        }}>
            <div>
                Double Points Until Release date!!
            </div>
            <div>
                {countdown.days}D {countdown.hours}h {countdown.minutes}m {countdown.seconds}s left
            </div>
        </div >
        <Loyalty
            artist='kelli-leigh'
            title='30 days of rewards'
            subtitle='Get unreleased tracks, win backstage tickets or my stage outfits.'
            image={<ImageStack images={[{ isVideo: false, src: image.src }, { isVideo: false, src: image.src }]} size={200} />}
            logo={<div style={{ textAlign: 'center' }}><Image src={logo} unoptimized width={148} height={88} /></div>}
        />
    </>
}

export default Kelli;